import { CheckCircleIcon, CloseIcon } from '@chakra-ui/icons';
import {
    Button,
    FormControl,
    Flex,
    Heading,
    Input,
    Stack,
    Text,
    useColorModeValue,
    Box,
    FormLabel,
  } from '@chakra-ui/react';
import { useCallback, FormEvent, useState } from 'react';
import { ApiError } from '../fetch';
import { requestPassReset } from '../fetch/auth';


  
export const ForgotPasswordForm = ()=>{
    const [email, setEmail]=useState('');
    const [resOk,setResOk]=useState(false);
    const [error, setError] = useState('');
   
    
    const requestReset = useCallback(
        async (e: FormEvent | MouseEvent) => {
          e.preventDefault();
          setResOk(false);
          try{
           await requestPassReset(email,`${window.location.protocol}//${window.location.hostname}/resetpass/`);
           setResOk(true);
           setError('');
          }
          catch(e){
            setError((e as ApiError).message);

          }
        }
        ,[email]);
    return (
        <form onSubmit={requestReset} dir='rtl'>
          <fieldset disabled={resOk}>
      <Flex
        minH={'100vh'}
        
        justify={'center'}
        bg={useColorModeValue('gray.50', 'gray.800')}>
        <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
          <Stack align={'center'}>
            <Heading fontSize={'4xl'}>نسيت كلمة السر</Heading>
           
          </Stack>
          <Box
            rounded={'lg'}
            bg={useColorModeValue('white', 'gray.700')}
            boxShadow={'lg'}
            p={8}>
            <Stack spacing={4}>
            <Text fontSize={'lg'} color={'gray.600'}>سيتم إرسال بريد إلكتروني به طريقة الاستعادة</Text>
              <FormControl id="email">
                <FormLabel>البريد الإلكتروني</FormLabel>
                <Input placeholder='your-email@example.com' type="email" value={email} onChange={e => setEmail(e.target.value)}/>
              </FormControl>
              
          
              <Stack spacing={10}>
                       
                <Button
                type='submit' 
                  bg={'blue.400'}
                  color={'white'}
                  _hover={{
                    bg: 'blue.500',
                  }}>
                  طلب استعادة
                </Button>
               
              </Stack>
              {resOk && 
              <Stack justifyContent={'center'} direction={'row'} spacing={2}>
                <CheckCircleIcon boxSize={'20px'} color={'green.500'} />                           
                <Text color="green">تم إرسال بريد إلكتروني</Text>               
              </Stack>             
              }

              {!!error &&
               <Stack justifyContent={'center'} direction={'row'} spacing={2}>
                <CloseIcon boxSize={'20px'} color={'white'} />
               <Text color="red.700">{error}</Text>             
               </Stack>
               }
            </Stack>
          </Box>
        </Stack>
       
      </Flex>
      </fieldset>
      </form>
    );
  }
  